module.exports = __webpack_public_path__ + "media/common/img/michael_tesalona-21daf9663d36f2f2b4791db1af9e7af1.jpg";